import React from 'react';
import styles from '../../../styles/widgets/pension-finder/pension-finder-header.module.scss';
import { CompanyAvatar } from './avatar';

const Component = React.memo(({ index, title, subTitle }) => (
  <hgroup className={styles.header}>
    <div className={styles.description}>
      <h2 className={styles.title}>{title}</h2>
      <p className={styles.subtitle}>{subTitle}</p>
    </div>
    <CompanyAvatar index={index} title={title} />
  </hgroup>
));

export const CompanyHeader = Component;
